import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AppProvider } from './contexts/AppContext';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext_NEW';
import { Layout } from './components/layout';

// Public Pages
import HomePage from './pages/public/HomePage';
import AboutPage from './pages/public/AboutPage';
import ServicesPage from './pages/public/ServicesPage';
import DoctorsPage from './pages/public/DoctorsPage';
import ContactPage from './pages/public/ContactPage';
import BookingPage from './pages/public/BookingPage';
import LoginPage from './pages/public/LoginPage';

// Patient Pages
import PatientDashboard from './pages/patient/PatientDashboard';
import PatientAppointments from './pages/patient/PatientAppointments';
import PatientProfile from './pages/patient/PatientProfile';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminAppointments from './pages/admin/AdminAppointments';
import AdminPatients from './pages/admin/AdminPatients';
import AdminDoctors from './pages/admin/AdminDoctors';
import AdminReports from './pages/admin/AdminReports';
import AdminSettings from './pages/admin/AdminSettings';

import './App.css';

const App: React.FC = () => {
    return (
    <AppProvider>
      <AuthProvider>
        <DataProvider>
          <Router>
            <div className="App">
              <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <Layout>
                <HomePage />
              </Layout>
            } />
            <Route path="/about" element={
              <Layout>
                <AboutPage />
              </Layout>
            } />
            <Route path="/services" element={
              <Layout>
                <ServicesPage />
              </Layout>
            } />
            <Route path="/doctors" element={
              <Layout>
                <DoctorsPage />
              </Layout>
            } />
            <Route path="/contact" element={
              <Layout>
                <ContactPage />
              </Layout>
            } />
            <Route path="/booking" element={
              <Layout>
                <BookingPage />
              </Layout>
            } />
            <Route path="/login" element={
              <Layout>
                <LoginPage />
              </Layout>
            } />

            {/* Patient Routes */}
            <Route path="/patient" element={
              <Layout showHeader={true} showFooter={false}>
                <PatientDashboard />
              </Layout>
            } />
            <Route path="/patient/appointments" element={
              <Layout showHeader={true} showFooter={false}>
                <PatientAppointments />
              </Layout>
            } />
            <Route path="/patient/profile" element={
              <Layout showHeader={true} showFooter={false}>
                <PatientProfile />
              </Layout>
            } />

            {/* Admin Routes */}
            <Route path="/admin" element={
              <Layout showHeader={false} showFooter={false}>
                <AdminDashboard />
              </Layout>
            } />
            <Route path="/admin/appointments" element={
              <Layout showHeader={false} showFooter={false}>
                <AdminAppointments />
              </Layout>
            } />
            <Route path="/admin/patients" element={
              <Layout showHeader={false} showFooter={false}>
                <AdminPatients />
              </Layout>
            } />
            <Route path="/admin/doctors" element={
              <Layout showHeader={false} showFooter={false}>
                <AdminDoctors />
              </Layout>
            } />
            <Route path="/admin/reports" element={
              <Layout showHeader={false} showFooter={false}>
                <AdminReports />
              </Layout>
            } />
            <Route path="/admin/settings" element={
              <Layout showHeader={false} showFooter={false}>
                <AdminSettings />
              </Layout>
            } />
          </Routes>
          
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
    </div>
        </Router>
      </DataProvider>
    </AuthProvider>
    </AppProvider>
  );
};

export default App;
